<template>
  <div
    ref="desc"
    class="LKPublicationsCardDesc"
    @click="onClick"
    v-html="text"
  />
</template>

<script>
export default {
  name: 'LKPublicationsCardDesc',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const { desc } = this.$refs
    this.$nextTick(() => {
      const tablesCells = desc.querySelectorAll('table tr td')
      tablesCells.forEach((el) => {
        const cell = el
        if (cell.dataset.colwidth) {
          cell.width = cell.dataset.colwidth
          cell.style.minWidth = `${cell.dataset.colwidth}px`
        }
      })

      const tables = desc.querySelectorAll('table')
      tables.forEach((el) => {
        const table = el
        table.outerHTML = `<div class="LKPublicationsCardDesc__table-wrapper">${table.outerHTML}</div>`
      })
    })
  },
  methods: {
    onClick({ target }) {
      if (target.nodeName === 'IMG') {
        target.classList.toggle('is-active')
      }
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsCardDesc {
  p {
    margin-bottom: 20px;
    font-weight: initial;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: $webflow-color-blue-dark;
  }

  img {
    max-width: 50%;

    &.is-active {
      max-width: 100%;
    }
  }

  &__table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
  }

  tr:first-child td,
  th {
    background-color: $webflow-color-blue-light;
  }

  // stylelint-disable-next-line no-descending-specificity
  td {
    box-sizing: border-box;
    padding: 3px 5px;
    border: 1px solid $webflow-color-blue-hover;
  }
}
</style>
